import { CustomProperty, CustomPropertyType } from '@evidentid/tprm-portal-lib/models/dashboard';

export function isCredentialTypesCustomProperty(customProperty: CustomProperty): boolean {
    return customProperty.type === CustomPropertyType.credentialTypes;
}
